// Styled Components
import styled from "styled-components";

const InfoOne = () => {
  return (
    <Wrapper>
      <div className="content">
        <p className="header">25 COMPLETE SHOEUZIS SCATTERED ACROSS 6K NFTS</p>
        <p className="info-1">
        The shoeuzi nft project is made of 6,000 randomly generated ‘Scattered’ shoeuzis. Each scattered shoeuzi nft is split into 4 pieces and mixed with others, people need to collect all the matching parts of a complete design to generate the ‘Complete’ shoeuzi nft.
        </p>
        <p className="info-2">
        Complete shoeuzis nfts are playable in the first person shooter multiplayer battle royale we are building with Unreal Engine (imagine Fortnite but with nfts)
        </p>

        <p className="info-2">
        If you collect 10 complete shoeuzi nfts you also get one made for you in real life. A custom 1/1.
        </p>
      </div>

      <video
        autoPlay={true}
        loop={true}
        playsInline={true}
        className="video"
        muted
      >
        <source
          src={process.env.PUBLIC_URL + "/videos/allshoeuzi.mp4"}
          type="video/mp4"
        />
      </video>
    </Wrapper>
  );
};

export default InfoOne;

const Wrapper = styled.div`
  width: 100%;
  padding: 0 20px;
  //
  padding-top: 250px;
  @media only screen and (max-width: 1000px) {
    padding-top: 100px;
  }
  //

  //
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  @media only screen and (max-width: 1075px) {
    flex-direction: column;
    gap: 50px;
  }
  //

  .content {
    display: flex;
    flex-direction: column;
    gap: 30px;

    .header {
      font-family: "Pixeltype";
      font-weight: 200;
      font-style: normal;
      font-size: 2rem;
      line-height: 45px;

      //
      width: 520px;
      @media only screen and (max-width: 550px) {
        width: 100%;
      }
      //
    }

    .info {
      &-1 {
        //
        width: 520px;
        @media only screen and (max-width: 550px) {
          width: 100%;
        }
        //

        font-size: 1.2rem;

        line-height: 31px;

        color: #fff;
        font-family: "Open Sans", sans-serif;
        font-weight: 300;
      }

      &-2 {
        //
        width: 520px;
        @media only screen and (max-width: 550px) {
          width: 100%;
        }
        //
        color: #8f8f8f;
        font-size: 1.2rem;

        line-height: 31px;

        color: #fff;
        font-family: "Open Sans", sans-serif;
        font-weight: 300;
      }
    }
  }

  .video {
    width: 400px;

    //
    width: 520px;
    @media only screen and (max-width: 550px) {
      width: 100%;
    }
    //
  }
`;
